import React from "react";
import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Modal, { ModalFooter } from "@amzn/meridian/esm/components/modal";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import aimsTheme from "../../meridian-theme-aims.json";
import { Box, Icon } from "@amzn/meridian";
import errorIcon from "../../images/error_icon.svg";

/**
 * Modal to inform organizer that AIMS is not responding.
 * This is a popup window for error handling.
 *
 * @param {boolean} isOpen - Controls the modal visibility
 * @param {Function} onClose - Callback to close the modal
 * @returns {JSX.Element}
 */
const ServerNotRespondingModal = ({ isOpen, onClose }) => {
  return (
    <Theme
      palette={aimsTheme}
      tokens={{
        modalHeaderBackgroundColor: "rgba(124, 209, 187, 0.6)",
        modalHeaderSpacingInsetTop: "0px",
        modalHeaderSpacingInsetBottom: "0px",
        modalHeaderFontSize: "8px",
        modalHeaderMinHeight: "8px",
        modalFooterBorderColor: "#FFFFFF",
      }}
    >
      <Modal
        open={isOpen}
        closeLabel={null}
        shouldCloseOnOverlayClick={true}
        aria-describedby="modal-description"
        fullscreenBreakpoint="0"
        title=" "
        bodySpacingInset="400"
        width="292px"
      >
        <Column spacing="none" spacingInset="none" height="204px">
          <Column height="16px" />
          <Column spacing="none" spacingInset="none">
            <Row alignmentHorizontal="center" widths="40" spacing="none" spacingInset="none">
              <img src={errorIcon} alt="errorIcon" style={{ display: "block", margin: "auto", width: "40px", height: "auto" }} />
            </Row>
          </Column>
          <Column height="16px" />
          <Column spacing="none" spacingInset="none">
            <Row spacing="none" spacingInset="none">
              <Row width="28px" />
              <Text fontFamily="amazonEmber" type="h100" alignment="start">
                Server not responding
              </Text>
            </Row>
          </Column>
          <Column height="8px" />
          <Column spacing="none" spacingInset="none">
            <Row spacing="none" spacingInset="none">
              <Row width="28px" />
              <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
                <Box type="outline" spacingInset="none" width="204px" height="40px">
                  <Text fontFamily="amazonEmber" type="b200" alignment="start">
                    Summarizing meeting isn’t available now.
                  </Text>
                </Box>
              </Theme>
            </Row>
          </Column>
          <Column height="16px" />
          <Column>
            <Row alignmentHorizontal="center" widths="194px" spacing="none" spacingInset="none">
              <Button type="primary" size="small" minWidth="194px" onClick={onClose}>
                OK
              </Button>
            </Row>
          </Column>
        </Column>
      </Modal>
    </Theme>
  );
};

export default ServerNotRespondingModal;
